import React, { useEffect, useRef } from 'react';
import '../styles/events.css';

// Replace this placeholder when the live event link is available.
const EVENT_URL = 'https://www.mixhaus.ca/event-details/whats-next-redeemordie';
const POSTER = '/RMD-party-poster.png';

const Events: React.FC = () => {
  const dialogRef = useRef<HTMLDialogElement>(null);
  const posterRef = useRef<HTMLButtonElement>(null);
  const previousOverflow = useRef('');

  useEffect(() => {
    window.scrollTo(0, 0);
    const dialog = dialogRef.current;
    const previousTitle = document.title;
    document.title = 'Events — REDEEMORDIE';
    return () => {
      document.title = previousTitle;
      if (dialog?.open) document.body.style.overflow = previousOverflow.current;
    };
  }, []);

  const openEvent = () => {
    previousOverflow.current = document.body.style.overflow;
    dialogRef.current?.showModal();
    document.body.style.overflow = 'hidden';
  };

  const restorePage = () => {
    document.body.style.overflow = previousOverflow.current;
    posterRef.current?.focus();
  };

  return (
    <div className="events-page">
      <header className="events-header">
        <div className="events-eyebrow"><span>REDEEMORDIE / OFFLINE</span><span>EST. 2021</span></div>
        <div className="events-header-bottom"><p>Out of the everyday. Into the night.</p><span>TORONTO, CA ↗</span></div>
      </header>

      <section className="events-list" aria-labelledby="events-list-title">
        <div className="events-section-heading"><h2 id="events-list-title">ON THE CALENDAR</h2><span>01 EVENT</span></div>
        <article className="events-feature">
          <button ref={posterRef} className="events-poster" onClick={openEvent} aria-label="View details for What's next: REDEEMORDIE?">
            <img src={POSTER} alt="What's next: REDEEMORDIE? party poster" />
            <span className="events-poster-cta">EXPLORE THE EVENT <span aria-hidden="true">↗</span></span>
          </button>
          <div className="events-feature-copy">
            <span className="events-kicker">THE NEXT GATHERING / 001</span>
            <p className="events-date"><time dateTime="2026-10-16">16.10.26</time></p>
            <h3>WHAT’S NEXT:<br />REDEEMORDIE?</h3>
            <p className="events-description">One night. Our people. Live performances and sounds that keep you moving until 3 AM.</p>
            <div className="events-location"><span>DOPAMINE / TORONTO</span><span>10 PM — 3 AM</span></div>
            <button className="events-details-button" onClick={openEvent}>VIEW EVENT DETAILS <span aria-hidden="true">↗</span></button>
            <p className="events-credit">ACTIVATED BY MIX HAUS · TNCRSERIES</p>
          </div>
        </article>
      </section>

      <div className="events-outro"><span>BE PART OF WHAT’S NEXT.</span><p>See you on the other side.</p><span aria-hidden="true">↗</span></div>

      <dialog ref={dialogRef} className="event-dialog" aria-labelledby="event-title" onClose={restorePage} onClick={(event) => {
        if (event.target === event.currentTarget) dialogRef.current?.close();
      }}>
        <div className="event-dialog-inner">
          <button className="event-close" onClick={() => dialogRef.current?.close()} aria-label="Close event details" autoFocus>×</button>
          <div className="event-dialog-art"><img src={POSTER} alt="What's next: REDEEMORDIE? Full event poster" /></div>
          <div className="event-dialog-copy">
            <span className="events-kicker">REDEEMORDIE / EVENTS / 001</span>
            <h2 id="event-title">WHAT’S NEXT:<br />REDEEMORDIE?</h2>
            <p>A night of live performances and late-night sounds in Toronto. Activated by Mix Haus.</p>
            <dl className="event-facts">
              <div><dt>DATE</dt><dd>October 16, 2026</dd></div>
              <div><dt>TIME</dt><dd>10 PM — 3 AM <small>Toronto time · ends October 17</small></dd></div>
              <div><dt>LOCATION</dt><dd>Dopamine <small>Toronto, Canada</small></dd></div>
            </dl>
            <div className="event-lineup">
              <section><h3>PERFORMANCES</h3><ul><li>BLACBOYY</li><li>SANTAKLARA</li><li>MARGIELADAVET</li></ul></section>
              <section><h3>SOUND POLICY</h3><ul><li>DJ SPXNZO</li><li>AZEEZ</li><li>FEROH</li><li>XRMANI</li></ul></section>
            </div>
            <a className="event-link" href={EVENT_URL} target="_blank" rel="noopener noreferrer">VISIT EVENT PAGE <span aria-hidden="true">↗</span></a>
            <span className="events-credit">MIX HAUS / TNCRSERIES</span>
          </div>
        </div>
      </dialog>
    </div>
  );
};

export default Events;
